const {h, render, Component} = require('preact');

class CallUsLinkView extends Component {
  constructor(props) {
    super(props);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  render() {
    if (this.configFromDom && !this.configFromDom.isRegionNA) {
      return (
        <div class="call-us-link">
          {I18n.translate('js.modules.support.call_us_text')}&nbsp;
          <span class={'channel-text-available'}
                onClick={this.props.handleCallUsLink} data-bhw="web2018_callUs_link">
                  {I18n.translate('js.modules.shared.call_us')}
       </span>
        </div>
      )
    }
  }
}

module.exports = CallUsLinkView
